<template>
	<ul class="list-group">
		<li class="list-group-item list-group-item-action">
			<div class="list-group-menu">
				<div class="list-group-menu-data">
					Información de Pruebas
				</div>
				<div class="list-group-menu-options">
					<div class="btn-group">
						<button class="btn btn-info">
							View
						</button>
						<button class="btn btn-danger">
							Delete
						</button>
					</div>
				</div>
			</div>	
		</li>
	</ul>
</template>
<script>
	export default {
		
	}
</script>

<style>
	.list-group-menu {
	  overflow: hidden;
	  position: relative;
	  width: 100%;
	}

	.list-group-menu-active .list-group-menu-data {
	  float: left;
	  background-color: red;
	  margin-left: -90px;
	  /*! text-align: right; */
	}

	.list-group-menu-active .list-group-menu-options {
	  float: left;
	  margin-right: 0px;
	  display: inline-block;
	  background-color: blue;
	}


	.list-group-menu-data {
	  position: relative;
	  width: 100%;
	  -webkit-backface-visibility: hidden;
	  backface-visibility: hidden;
	  transition: -webkit-transform .6s ease-in-out;
	  transition: transform .6s ease-in-out;
	  transition: transform .6s ease-in-out,-webkit-transform .6s ease-in-out;
	}

	.list-group-menu-options {
	  position: relative;
	  display: none;
	  float: left;
	  width: 90px;
	  margin-right: -50%;
	  -webkit-backface-visibility: hidden;
	  backface-visibility: hidden;
	  transition: -webkit-transform .6s ease-in-out;
	  transition: transform .6s ease-in-out;
	  transition: transform .6s ease-in-out,-webkit-transform .6s ease-in-out;
	}
</style>